<!-- 企业资质弹窗/使用人 -->
<template> 
    <div>
        <el-dialog v-dialogDrag :title="enterpriseCode === 0 ? '编辑企业资质信息':'编辑使用人信息'" :visible.sync="enterpriseShow" width="60%" :before-close="handleClose" :close-on-click-modal="false">
           <el-form  :model="formValue"  size="mini" label-width="130px">
                <el-row :gutter="24" v-if="enterpriseCode === 0">
                    <el-col :span="12">
                        <el-form-item label="企业资质类别">
                            <el-select class="width_100" filterable placeholder="请选择企业资质类别">
                                <el-option v-for="item in enterpriseList" :key="item.codeValue" :label="item.codeName" :value="item.codeValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="企业资质编号">
                            <el-input  placeholder="请输入企业资质编号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24" v-else >
                    <el-col :span="12">
                        <el-form-item label="使用单位联系人">
                            <el-input  placeholder="请输入使用单位联系人"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="使用单位联系电话">
                            <el-input  placeholder="请输入使用单位联系电话"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div>
                <el-button type="primary" icon="el-icon-plus" size="mini">新增</el-button>
                <el-button type="primary" icon="el-icon-document-checked" size="mini">保存</el-button>
                <el-button type="primary" icon="el-icon-copy-document" size="mini">删除</el-button>
            </div>
            <el-table :data="tableData" style="width: 100%" size="mini" height="200px" v-if="enterpriseCode === 0">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="" label="企业资质类别代码" > </el-table-column>
                <el-table-column prop="" label="企业资质类别名称"> </el-table-column>
                <el-table-column prop="" label="企业资质编号"> </el-table-column>
            </el-table>
            <el-table :data="tableData" style="width: 100%" size="mini" height="200px" v-else>
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="" label="使用单位联系人" > </el-table-column>
                <el-table-column prop="" label="使用单位联系电话"> </el-table-column>
            </el-table>
            <div v-if="enterpriseCode === 0">
                <el-checkbox >企业承诺：本单位持有海关要求的合格保证、标签标识及其他证明声明材料，知悉相关材料内容，保证符合法律法规要求，并自存留档。</el-checkbox>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        enterpriseShow: {
            type: Boolean,
            default: false
        },
        enterpriseCode: {
            type: Number,
            default: 0, // 0 企业资质  1 使用人信息
        },
    },
    data() {
        return {
            enterpriseList:[],
            formValue:{},
            tableData:[],
        }
    },
    watch: {
    },
    mounted() { 

    },
    methods: { 
        handleClose() {
            this.$emit('enterpriseClose', false);
        }
    }
}
</script>
<style lang="css" scoped>
.width_100{
    width: 100%;
}
.el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
.el-checkbox{
    white-space: normal;
    display: flex;
    align-self: flex-start;
    margin-top: 10px;
}
</style>